(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["on-breadcrumbs"] && !Shopify.designMode) return;
  try {
    /* On breadcrumbs: when the Women | Men toggle changes, the trail changes with it. All trails of the product are in the page
     (data-trails), so nothing is fetched. For separate Women / Men products the toggle announces the gender first
     (on:gender-change) and the product page that is loaded afterwards brings the exact trail (on:pdp-swap). */
  (function () {
    if (window.__onBreadcrumbs) return;
    window.__onBreadcrumbs = true;

    var SEP = '<span class="on-bc__sep" aria-hidden="true"><svg width="5" height="9" viewBox="0 0 5 9" fill="none" stroke="currentColor" stroke-width="1" focusable="false"><path d="M.5.5l4 4-4 4"/></svg></span>';

    /* "Women", "Womens", "Female" -> women, "Men", "Mens", "Male" -> men, anything else stays as typed (lower case) */
    function norm(value) {
      var v = String(value == null ? '' : value).trim().toLowerCase();
      if (/women|woman|female|ladies|نساء/.test(v)) return 'women';
      if (/men|man|male|رجال/.test(v)) return 'men';
      return v;
    }

    /* the trails live in the block above the title; the header copy (phone) only mirrors it */
    function block() { return document.querySelector('.on-bc--block[data-on-breadcrumbs]'); }
    function source() { var b = block(); return b && b.hasAttribute('data-trails') ? b : null; }
    function safe(url) { return /^\s*javascript:/i.test(url || '') ? '#' : url; }

    function build(nav, trail, home) {
      var ol = nav.querySelector('.on-bc__list');
      if (!ol) return;
      var items = trail.slice();
      if (home) items.unshift(home);
      ol.textContent = '';
      items.forEach(function (c, i) {
        var li = document.createElement('li');
        li.className = 'on-bc__item';
        var el;
        if (c[1]) { el = document.createElement('a'); el.href = safe(c[1]); } else { el = document.createElement('span'); }
        el.className = 'on-bc__link';
        var u = document.createElement('span');
        u.className = 'on-bc__u';
        u.textContent = c[0];
        el.appendChild(u);
        li.appendChild(el);
        if (i < items.length - 1) li.insertAdjacentHTML('beforeend', SEP);
        ol.appendChild(li);
      });
    }

    function copyToMirrors(src) {
      var list = src.querySelector('.on-bc__list');
      if (!list) return;
      var html = list.innerHTML;
      document.querySelectorAll('[data-on-breadcrumbs]').forEach(function (nav) {
        if (nav === src) return;
        var ol = nav.querySelector('.on-bc__list');
        if (ol) ol.innerHTML = html;
      });
    }

    function apply(value) {
      var src = source();
      if (!src || value == null || value === '') return;
      var trails;
      try { trails = JSON.parse(src.getAttribute('data-trails')); } catch (e) { return; }
      var key = norm(value);
      var trail = trails[key];
      if (!trail) return;
      var home = src.getAttribute('data-home-label') ? [src.getAttribute('data-home-label'), src.getAttribute('data-home-url')] : null;
      build(src, trail, home);
      src.setAttribute('data-gender', key);
      copyToMirrors(src);
    }

    /* the Gender option of a product with Women and Men variants: Dawn's radios are named "Gender-1" */
    document.addEventListener('change', function (event) {
      var src = source();
      var t = event.target;
      if (!src || !t || !t.name) return;
      var names = (src.getAttribute('data-gender-option') || '').toLowerCase().split(',');
      var name = String(t.name).toLowerCase();
      var hit = names.some(function (opt) {
        opt = opt.trim();
        return opt && (name === opt || name.indexOf(opt + '-') === 0);
      });
      if (!hit) return;
      if (t.type === 'radio' && !t.checked) return;
      apply(t.value);
    });

    /* any other toggle can tell the breadcrumbs directly:  document.dispatchEvent(new CustomEvent('on:gender-change', { detail: { value: 'Men' } })) */
    document.addEventListener('on:gender-change', function (event) { apply(event.detail && event.detail.value); });

    /* the header copy (phone) is rendered without the block settings, so it takes the block's trail */
    function init() {
      var src = block();
      if (src && document.querySelector('.on-bc--header')) copyToMirrors(src);
    }
    /* the product area was replaced (separate Women / Men products): the header copy takes the new trail */
    document.addEventListener('on:pdp-swap', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["on-card-product"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__onCardSwatchesInit) return;
    window.__onCardSwatchesInit = true;

    /* ---------- Change the main image when a swatch is chosen ---------- */
    function activate(btn) {
      if (!btn || btn.classList.contains('is-active')) return;
      var card = btn.closest('.on-card');
      if (!card) return;

      card.querySelectorAll('.on-card__swatch').forEach(function (swatch) {
        var on = swatch === btn;
        swatch.classList.toggle('is-active', on);
        swatch.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      // The card links now open the chosen color
      if (btn.dataset.url) {
        card.querySelectorAll('[data-on-link]').forEach(function (link) {
          link.setAttribute('href', btn.dataset.url);
        });
      }
      card.classList.add('is-swatched');

      var img = card.querySelector('.on-card__main-image');
      var src = btn.dataset.image;
      var srcset = btn.dataset.srcset;
      if (!img || !src) return;

      var token = String(Date.now()) + Math.random();
      card.dataset.swapToken = token;

      // Preload the new image so the swap never shows an empty frame
      var loader = new Image();
      if (srcset) loader.srcset = srcset;
      if (img.sizes) loader.sizes = img.sizes;
      loader.src = src;

      var swap = function () {
        if (card.dataset.swapToken !== token) return;
        img.style.opacity = '0';
        window.setTimeout(function () {
          if (card.dataset.swapToken !== token) return;
          if (srcset) img.srcset = srcset;
          img.src = src;
          img.style.opacity = '1';
        }, 160);
      };

      if (loader.decode) {
        loader.decode().then(swap, swap);
      } else if (loader.complete) {
        swap();
      } else {
        loader.onload = swap;
        loader.onerror = swap;
      }
    }

    /* Swatch rows can hold many colors: let a mouse drag them sideways (touch scrolls natively).
       This listener runs first and cancels the click that ends a drag. */
    var suppressClick = false;
    document.addEventListener(
      'click',
      function (event) {
        if (!suppressClick) return;
        suppressClick = false;
        if (event.target.closest && event.target.closest('.on-card__swatches')) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    document.addEventListener('click', function (event) {
      var btn = event.target.closest ? event.target.closest('.on-card__swatch') : null;
      if (btn) activate(btn);
    });

    // Optional: switch on hover (desktop), controlled by the "swatch_hover" setting
    document.addEventListener('mouseover', function (event) {
      var btn = event.target.closest ? event.target.closest('.on-card__swatch') : null;
      if (!btn) return;
      var card = btn.closest('.on-card');
      if (card && card.dataset.swatchHover === 'true') activate(btn);
    });

    var drag = null;
    document.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      var row = event.target.closest ? event.target.closest('.on-card__swatches') : null;
      if (!row || row.scrollWidth <= row.clientWidth + 1) return;
      drag = { row: row, x: event.clientX, left: row.scrollLeft, moved: false };
    });

    document.addEventListener('pointermove', function (event) {
      if (!drag) return;
      var dx = event.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 5) return;
        drag.moved = true;
        drag.row.classList.add('is-dragging');
      }
      drag.row.scrollLeft = drag.left - dx;
    });

    function endDrag() {
      if (!drag) return;
      if (drag.moved) {
        suppressClick = true;
        window.setTimeout(function () { suppressClick = false; }, 120);
      }
      drag.row.classList.remove('is-dragging');
      drag = null;
    }
    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["on-gender-toggle"] && !Shopify.designMode) return;
  try {
    /* Links mode: the other product is fetched and the product area (<main>) is replaced, like on.ae does for its Gender option. */
  if (!customElements.get('on-gender-toggle')) {
    (function () {
      var CACHE_MS = 60000;
      var cache = {};
      var busy = false;
      var shown = window.location.pathname;   /* the product that is on screen */

      function load(url) {
        var hit = cache[url];
        if (hit && Date.now() - hit.at < CACHE_MS) return hit.p;
        var p = fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'on-gender-toggle' } }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        });
        cache[url] = { at: Date.now(), p: p };
        p.catch(function () { delete cache[url]; });
        return p;
      }

      /* scripts that arrive through DOMParser do not run: rebuild the executable ones (what Dawn's HTMLUpdateUtility does too).
         A script file that is already on the page is not loaded twice. */
      function revive(scope) {
        scope.querySelectorAll('script').forEach(function (old) {
          var type = (old.getAttribute('type') || '').toLowerCase();
          if (type && type.indexOf('javascript') === -1 && type !== 'module') return;
          var src = old.getAttribute('src');
          if (src && Array.prototype.some.call(document.scripts, function (s) { return s !== old && s.getAttribute('src') === src; })) return;
          var s = document.createElement('script');
          Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
          s.textContent = old.textContent;
          old.replaceWith(s);
        });
      }

      function swap(url, push) {
        return load(url).then(function (html) {
          delete cache[url];
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('main');
          var current = document.querySelector('main');
          if (!next || !current) throw new Error('no <main>');
          document.title = doc.title || document.title;
          /* the markup is parsed again by THIS document (innerHTML of a loose <div>), not taken from the DOMParser one: that parser has
             scripting off and turns <noscript> fallbacks (a visible size list, a hidden size button, ...) into live elements and styles */
          var holder = document.createElement('div');
          holder.innerHTML = next.outerHTML;
          var adopted = holder.firstElementChild;
          current.replaceWith(adopted);
          revive(adopted);
          if (push) {
            try { history.pushState({ onGender: true }, '', url); } catch (e) {}
          }
          shown = new URL(url, window.location.href).pathname;
          window.scrollTo(0, 0);
          document.dispatchEvent(new CustomEvent('on:pdp-swap', { detail: { url: url } }));
          var now = adopted.querySelector('on-gender-toggle .on-gender__item[aria-current]');
          if (now && push) now.focus({ preventScroll: true });
        });
      }

      /* Back / Forward: Dawn rewrites the history state when a colour is picked (?variant=), so the product on screen is tracked by its path */
      window.addEventListener('popstate', function () {
        if (!document.querySelector('on-gender-toggle') || window.location.pathname === shown) return;
        swap(window.location.href, false).catch(function () { window.location.reload(); });
      });

      customElements.define(
        'on-gender-toggle',
        class OnGenderToggle extends HTMLElement {
          connectedCallback() {
            this.onClick = this.onClick.bind(this);
            this.onWarm = this.onWarm.bind(this);
            this.addEventListener('click', this.onClick);
            ['pointerover', 'focusin', 'touchstart'].forEach(function (name) { this.addEventListener(name, this.onWarm, { passive: true }); }, this);
          }

          disconnectedCallback() {
            this.removeEventListener('click', this.onClick);
            ['pointerover', 'focusin', 'touchstart'].forEach(function (name) { this.removeEventListener(name, this.onWarm); }, this);
          }

          link(event) {
            var a = event.target.closest ? event.target.closest('a[data-gender]') : null;
            return a && this.contains(a) ? a : null;
          }

          /* the other product is fetched while the pointer is still on its way (Dawn does the same for product cards) */
          onWarm(event) {
            var a = this.link(event);
            if (!a || a.hasAttribute('aria-current') || this.dataset.swap !== 'true') return;
            load(a.href).catch(function () {});
          }

          onClick(event) {
            var a = this.link(event);
            if (!a) return;
            if (a.hasAttribute('aria-current')) {
              event.preventDefault();
              return;
            }
            if (this.dataset.swap !== 'true' || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            if (busy) return;
            busy = true;
            this.setAttribute('aria-busy', 'true');

            /* instant feedback: the pill flips and the breadcrumbs show the new trail while the page is on its way */
            this.querySelectorAll('a[data-gender]').forEach(function (item) {
              var on = item === a;
              item.classList.toggle('is-current', on);
              if (on) item.setAttribute('aria-current', 'page');
              else item.removeAttribute('aria-current');
            });
            document.dispatchEvent(new CustomEvent('on:gender-change', { detail: { value: a.dataset.gender } }));

            var url = a.href;
            swap(url, true).then(
              function () { busy = false; },
              function () { busy = false; window.location.href = url; }
            );
          }
        }
      );
    })();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["on-mega-menu"] && !Shopify.designMode) return;
  try {
    /* ---------------------------------------------------------------------------
     <on-mega-menu>  - the On-style menu: open / close, accordion, mobile drawer, keyboard
     Header state    - homepage only: transparent -> solid on scroll, --on-header-h, hold while search / account is open
     No libraries. Safe to load twice (guarded) and safe in the theme editor.
     Timings are the ones measured on on.ae: 300ms hover intent, 200ms fades.
  --------------------------------------------------------------------------- */
  if (!customElements.get('on-mega-menu')) {
    customElements.define(
      'on-mega-menu',
      class OnMegaMenu extends HTMLElement {
        connectedCallback() {
          this.panel = this.querySelector('.on-mega__panel');
          if (!this.panel) return;

          this.abort = new AbortController();
          const signal = this.abort.signal;
          const on = (target, type, fn, options) =>
            target.addEventListener(type, fn, Object.assign({ signal: signal }, options || {}));

          this.openDelay = parseInt(this.dataset.openDelay, 10) || 300;
          this.switchDelay = parseInt(this.dataset.switchDelay, 10) || 300;
          this.hoverDelay = parseInt(this.dataset.hoverDelay, 10) || 300;
          this.desktopQuery = window.matchMedia('(min-width: 1024px)');
          this.isOpen = false;
          this.active = -1;
          this.lastPointer = 'mouse';
          this.lastFocus = null;

          this.cover = this.querySelector('[data-on-cover]');
          this.backButton = this.querySelector('[data-on-back]');
          this.items = Array.from(this.querySelectorAll('.on-mega__l1-item'));
          this.triggers = Array.from(this.querySelectorAll('.on-mega__trigger[data-on-index]'));
          this.setBurger = () => {
            this.burgers = Array.from(document.querySelectorAll('[data-on-burger]'));
            return this.burgers;
          };
          this.setBurger();

          /* ----- level 1 in the header bar (desktop) ----- */
          this.triggers.forEach((trigger) => {
            const index = parseInt(trigger.dataset.onIndex, 10);
            on(trigger, 'pointerenter', (event) => {
              if (event.pointerType !== 'mouse' || !this.desktop()) return;
              clearTimeout(this.hoverTimer);
              if (this.isOpen && this.active === index) return;
              this.hoverTimer = setTimeout(() => this.open(index), this.isOpen ? this.switchDelay : this.openDelay);
            });
            on(trigger, 'pointerleave', () => clearTimeout(this.hoverTimer));
            on(trigger, 'click', (event) => {
              if (!this.desktop()) return;
              event.preventDefault();
              clearTimeout(this.hoverTimer);
              if (this.isOpen && this.active === index) {
                // a mouse click on an item that hover already opened keeps it open; keyboard / touch toggle it
                if (event.detail === 0 || this.lastPointer !== 'mouse') this.close({ restoreFocus: true });
              } else {
                this.open(index);
              }
            });
            on(trigger, 'keydown', (event) => {
              if (event.key === 'ArrowDown' || event.key === ' ') {
                event.preventDefault();
                this.open(index, { focusFirst: true });
              }
            });
          });

          /* ----- level 2 (desktop hover = accordion, touch / keyboard) ----- */
          this.querySelectorAll('.on-mega__l2-item').forEach((li) => {
            on(li, 'pointerenter', (event) => {
              if (event.pointerType !== 'mouse' || !this.desktop() || !this.isOpen) return;
              clearTimeout(this.itemTimer);
              if (li.classList.contains('is-expanded') || !li.classList.contains('has-sub')) return;
              this.itemTimer = setTimeout(() => this.expand(li), this.hoverDelay);
            });
            on(li, 'pointerleave', () => clearTimeout(this.itemTimer));
          });

          on(this, 'pointerdown', (event) => {
            this.lastPointer = event.pointerType || 'mouse';
          }, { capture: true });

          on(this, 'click', (event) => {
            const l2 = event.target.closest && event.target.closest('.on-mega__l2-link');
            if (l2 && this.contains(l2)) {
              const li = l2.closest('.on-mega__l2-item');
              if (li.classList.contains('has-sub')) {
                // mobile: the row toggles the accordion. desktop with touch: first tap opens it, second tap follows the link.
                const touchOnDesktop = this.desktop() && this.lastPointer !== 'mouse' && event.detail > 0;
                if (!this.desktop() || touchOnDesktop) {
                  if (!li.classList.contains('is-expanded')) {
                    event.preventDefault();
                    this.expand(li);
                  } else if (!this.desktop()) {
                    event.preventDefault();
                    this.collapse(li);
                  }
                }
              }
              return;
            }
            const drill = event.target.closest && event.target.closest('[data-on-drill]');
            if (drill && this.contains(drill) && !this.desktop()) {
              event.preventDefault();
              this.open(parseInt(drill.closest('.on-mega__l1-item').dataset.onIndex, 10));
            }
          });

          // keyboard focus on a level-2 link opens its accordion so the level-3 links are reachable
          on(this, 'focusin', (event) => {
            const li = event.target.closest && event.target.closest('.on-mega__l2-item');
            if (!li || !this.isOpen || !li.classList.contains('has-sub')) return;
            let keyboard = true;
            try {
              keyboard = event.target.matches(':focus-visible');
            } catch (error) {
              keyboard = true;
            }
            if (keyboard && this.desktop()) this.expand(li);
          });

          on(this, 'keydown', (event) => this.keyDown(event));

          if (this.cover) on(this.cover, 'click', () => this.close());
          if (this.backButton) on(this.backButton, 'click', () => this.back());

          on(document, 'click', (event) => {
            const burger = event.target.closest && event.target.closest('[data-on-burger]');
            if (!burger) return;
            if (this.isOpen) this.close({ restoreFocus: true });
            else this.openRoot();
          });
          on(document, 'keydown', (event) => {
            if (event.key === 'Escape' && this.isOpen) {
              event.preventDefault();
              this.close({ restoreFocus: true });
            }
          });
          // opening the search dialog or the account dialog closes the menu
          on(
            document,
            'toggle',
            (event) => {
              const el = event.target;
              if (this.isOpen && el && el.matches && el.matches('details') && el.open && el.closest('details-modal')) this.close();
            },
            { capture: true }
          );
          on(
            document,
            'open',
            (event) => {
              if (this.isOpen && event.target && event.target.matches && event.target.matches('shopify-account')) this.close();
            },
            { capture: true }
          );
          on(window, 'pageshow', (event) => {
            if (event.persisted) this.close();
          });
          const onBreakpoint = () => this.close();
          if (this.desktopQuery.addEventListener) on(this.desktopQuery, 'change', onBreakpoint);
          else this.desktopQuery.addListener(onBreakpoint);
        }

        disconnectedCallback() {
          if (this.abort) this.abort.abort();
          clearTimeout(this.hoverTimer);
          clearTimeout(this.itemTimer);
          if (this.isOpen) this.close();
        }

        desktop() {
          return this.desktopQuery.matches;
        }

        /* ---------- Open / close ---------- */
        open(index, options) {
          options = options || {};
          const item = this.items.find((el) => parseInt(el.dataset.onIndex, 10) === index);
          if (!item || !item.classList.contains('has-sub')) return;
          clearTimeout(this.hoverTimer);
          if (!this.isOpen) this.lastFocus = document.activeElement;
          this.isOpen = true;
          this.active = index;
          this.setAttribute('data-open', '');
          document.body.classList.add('on-menu-open');
          this.panel.inert = false;

          this.items.forEach((el) => {
            const active = el === item;
            el.classList.toggle('is-active', active);
            const drill = el.querySelector('[data-on-drill]');
            if (drill) drill.setAttribute('aria-expanded', active ? 'true' : 'false');
            if (!active) this.collapseAll(el);
          });
          this.triggers.forEach((trigger) => {
            const active = parseInt(trigger.dataset.onIndex, 10) === index;
            trigger.classList.toggle('is-active', active);
            trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
          });

          if (!this.desktop()) {
            const sub = item.querySelector('.on-mega__sub1');
            if (this.backButton) {
              this.backButton.querySelector('.on-mega__back-text').textContent = sub ? sub.dataset.title : '';
              this.backButton.tabIndex = 0;
            }
            document.body.classList.add('on-menu-l2');
          }
          this.syncBurger();
          if (options.focusFirst) {
            const first = item.querySelector('.on-mega__l2-link');
            if (first) first.focus({ preventScroll: true });
          }
          this.dispatchEvent(new CustomEvent('on-mega:toggle', { bubbles: true, detail: { open: true } }));
        }

        // mobile: the burger opens the drawer at level 1
        openRoot() {
          if (this.isOpen) return;
          this.lastFocus = document.activeElement;
          this.isOpen = true;
          this.active = -1;
          this.setAttribute('data-open', '');
          document.body.classList.add('on-menu-open');
          this.panel.inert = false;
          this.syncBurger();
          this.dispatchEvent(new CustomEvent('on-mega:toggle', { bubbles: true, detail: { open: true } }));
        }

        // mobile: "< Shop" goes back to level 1
        back() {
          this.active = -1;
          this.items.forEach((el) => {
            el.classList.remove('is-active');
            const drill = el.querySelector('[data-on-drill]');
            if (drill) drill.setAttribute('aria-expanded', 'false');
            this.collapseAll(el);
          });
          document.body.classList.remove('on-menu-l2');
          if (this.backButton) this.backButton.tabIndex = -1;
          const burger = this.burgers && this.burgers[0];
          if (burger) burger.focus({ preventScroll: true });
        }

        close(options) {
          options = options || {};
          clearTimeout(this.hoverTimer);
          clearTimeout(this.itemTimer);
          if (!this.isOpen) return;
          this.isOpen = false;
          this.active = -1;
          this.removeAttribute('data-open');
          document.body.classList.remove('on-menu-open', 'on-menu-l2');
          const focusInside = this.panel.contains(document.activeElement);
          this.panel.inert = true;
          this.items.forEach((el) => {
            el.classList.remove('is-active');
            const drill = el.querySelector('[data-on-drill]');
            if (drill) drill.setAttribute('aria-expanded', 'false');
            this.collapseAll(el);
          });
          this.triggers.forEach((trigger) => {
            trigger.classList.remove('is-active');
            trigger.setAttribute('aria-expanded', 'false');
          });
          if (this.backButton) this.backButton.tabIndex = -1;
          this.syncBurger();
          if (options.restoreFocus || focusInside) {
            const target = this.lastFocus && document.contains(this.lastFocus) ? this.lastFocus : null;
            if (target && target.focus) target.focus({ preventScroll: true });
          }
          this.dispatchEvent(new CustomEvent('on-mega:toggle', { bubbles: true, detail: { open: false } }));
        }

        syncBurger() {
          this.setBurger().forEach((burger) => {
            burger.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
            burger.setAttribute('aria-label', this.isOpen ? 'Close menu' : 'Open menu');
          });
        }

        /* ---------- Accordion (level 2 -> level 3) ---------- */
        expand(li) {
          const list = li.parentElement;
          list.querySelectorAll('.on-mega__l2-item.is-expanded').forEach((other) => {
            if (other !== li) this.collapse(other);
          });
          li.classList.add('is-expanded');
          const link = li.querySelector('.on-mega__l2-link[aria-expanded]');
          if (link) link.setAttribute('aria-expanded', 'true');
        }

        collapse(li) {
          li.classList.remove('is-expanded');
          const link = li.querySelector('.on-mega__l2-link[aria-expanded]');
          if (link) link.setAttribute('aria-expanded', 'false');
        }

        collapseAll(scope) {
          scope.querySelectorAll('.on-mega__l2-item.is-expanded').forEach((li) => this.collapse(li));
        }

        /* ---------- Keyboard ---------- */
        keyDown(event) {
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          const key = event.key;
          const target = event.target;
          const trigger = target.closest && target.closest('.on-mega__trigger');
          const l2Link = target.closest && target.closest('.on-mega__l2-link');
          const l3Link = target.closest && target.closest('.on-mega__l3-link');

          if (trigger) {
            if (key === 'ArrowRight' || key === 'ArrowLeft') {
              const all = Array.from(this.querySelectorAll('.on-mega__trigger'));
              const rtl = getComputedStyle(this).direction === 'rtl';
              const step = (key === 'ArrowRight') !== rtl ? 1 : -1;
              const next = all[(all.indexOf(trigger) + step + all.length) % all.length];
              if (next) {
                event.preventDefault();
                next.focus();
                if (this.isOpen && next.dataset.onIndex) this.open(parseInt(next.dataset.onIndex, 10));
              }
            }
            return;
          }

          if (l2Link) {
            const links = Array.from(l2Link.closest('.on-mega__l2').querySelectorAll('.on-mega__l2-link'));
            const index = links.indexOf(l2Link);
            if (key === 'ArrowDown' || key === 'ArrowUp') {
              event.preventDefault();
              const next = links[(index + (key === 'ArrowDown' ? 1 : -1) + links.length) % links.length];
              if (next) next.focus();
            } else if (key === 'ArrowRight') {
              const li = l2Link.closest('.on-mega__l2-item');
              const first = li.querySelector('.on-mega__l3-link');
              if (first) {
                event.preventDefault();
                this.expand(li);
                first.focus();
              }
            }
            return;
          }

          if (l3Link) {
            const links = Array.from(l3Link.closest('.on-mega__l3').querySelectorAll('.on-mega__l3-link'));
            const index = links.indexOf(l3Link);
            if (key === 'ArrowDown' || key === 'ArrowUp') {
              event.preventDefault();
              const next = links[(index + (key === 'ArrowDown' ? 1 : -1) + links.length) % links.length];
              if (next) next.focus();
            } else if (key === 'ArrowLeft') {
              const parent = l3Link.closest('.on-mega__l2-item').querySelector('.on-mega__l2-link');
              if (parent) {
                event.preventDefault();
                parent.focus();
              }
            }
          }
        }
      }
    );
  }

  /* ---------- Homepage transparent header ----------
     Only runs when theme.liquid put .on-is-home on <body> (home page only).
       .on-header-solid  = page scrolled (header turns white)
       .on-header-hold   = search or account dialog open (header stays white so the dialog is readable) */
  (function () {
    function init() {
      const body = document.body;
      if (!body || !body.classList.contains('on-is-home')) return;
      if (body.__onHeaderState) return;
      body.__onHeaderState = true;

      const wrapper = () => document.querySelector('.section-header .header-wrapper') || document.querySelector('.header-wrapper');
      const solidOnScroll = () => body.classList.toggle('on-header-solid', (window.pageYOffset || document.documentElement.scrollTop || 0) > 4);
      const measure = () => {
        const el = wrapper();
        if (el) document.documentElement.style.setProperty('--on-header-h', el.offsetHeight + 'px');
      };

      const holds = new Set();
      const syncHold = () => body.classList.toggle('on-header-hold', holds.size > 0);

      const isAccount = (event) => event.target && event.target.matches && event.target.matches('shopify-account');
      document.addEventListener('open', (event) => { if (isAccount(event)) { holds.add('account'); syncHold(); } }, true);
      document.addEventListener('close', (event) => { if (isAccount(event)) { holds.delete('account'); syncHold(); } }, true);
      document.addEventListener(
        'pointerdown',
        (event) => {
          if (holds.has('account') && !(event.target.closest && event.target.closest('shopify-account'))) {
            holds.delete('account');
            syncHold();
          }
        },
        true
      );
      // search modal (<details-modal><details>): the toggle event does not bubble, so listen while capturing
      document.addEventListener(
        'toggle',
        (event) => {
          const el = event.target;
          if (!el || !el.matches || !el.matches('details') || !el.closest('details-modal')) return;
          if (el.open) holds.add('search');
          else holds.delete('search');
          syncHold();
        },
        true
      );
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && holds.has('account')) {
          holds.delete('account');
          syncHold();
        }
      });

      window.addEventListener('scroll', solidOnScroll, { passive: true });
      window.addEventListener('resize', measure);
      // the theme editor swaps the header section in place
      document.addEventListener('shopify:section:load', () => {
        measure();
        solidOnScroll();
      });
      if ('ResizeObserver' in window) {
        const el = wrapper();
        if (el) new ResizeObserver(measure).observe(el);
      }
      measure();
      solidOnScroll();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["on-size-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('on-size-drawer')) {
    customElements.define(
      'on-size-drawer',
      class OnSizeDrawer extends HTMLElement {
        connectedCallback() {
          const raw = this.querySelector('[data-on-sd-data]');
          const template = this.querySelector('[data-on-sd-template]');
          this.trigger = this.querySelector('[data-on-sd-trigger]');
          this.triggerText = this.querySelector('[data-on-sd-trigger-text]');
          if (!raw || !template || !this.trigger) return;

          try {
            this.data = JSON.parse(raw.textContent);
          } catch (error) {
            return;
          }
          if (typeof this.data.ledger === 'string') {
            try {
              this.data.ledger = JSON.parse(this.data.ledger);
            } catch (error) {
              this.data.ledger = null;
            }
          }

          this.sizeName = this.dataset.sizeName;
          this.sizeIndex = parseInt(this.dataset.sizePosition, 10) - 1;
          this.genderIndex = (parseInt(this.dataset.genderPosition, 10) || 0) - 1; // -1 = no Gender option
          this.lowStock = parseInt(this.dataset.lowStock, 10) || 5;
          this.formId = this.dataset.formId;
          this.requireSize = this.dataset.requireSize === 'true';
          this.chosen = this.dataset.initialChosen === 'true';
          this.scope = this.closest('.shopify-section') || document;
          this.mq = window.matchMedia('(min-width: 750px)');
          this.isOpen = false;
          this.timers = [];

          // DOM teleportation: the panel moves to <body>, outside any theme container
          this.root = template.content.firstElementChild.cloneNode(true);
          document.body.appendChild(this.root);
          this.panel = this.root.querySelector('.on-sd-panel');
          this.list = this.root.querySelector('[data-on-sd-list]');

          this.onTrigger = () => (this.isOpen ? this.close() : this.open());
          this.onRootClick = (event) => this.rootClick(event);
          this.onKey = (event) => this.keyDown(event);
          this.onChange = (event) => this.nativeChanged(event);
          this.onResize = () => this.isOpen && this.position();
          this.onAddClick = (event) => this.addClick(event);

          this.trigger.addEventListener('click', this.onTrigger);
          this.root.addEventListener('click', this.onRootClick);
          document.addEventListener('keydown', this.onKey);
          document.addEventListener('change', this.onChange);
          document.addEventListener('click', this.onAddClick, true);
          window.addEventListener('resize', this.onResize);

          // Dawn re-renders the variant picker after every change: hide the new native size control right away
          // (a MutationObserver callback runs before the browser paints, so the pills never show)
          this.observer = new MutationObserver((mutations) => {
            if (mutations.some((m) => m.addedNodes.length && !this.contains(m.target))) {
              this.hideNative();
              this.refreshTrigger();
            }
          });
          this.observer.observe(this.scope, { childList: true, subtree: true });

          // Dawn's own "variant changed" event (after the product info has been refreshed)
          try {
            if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => this.afterVariantChange());
            }
          } catch (error) {
            this.unsubscribe = null;
          }

          // Keep the trigger exactly as wide as the "Add to cart" button
          this.onWidth = () => this.syncWidth();
          window.addEventListener('resize', this.onWidth);
          window.addEventListener('load', this.onWidth);
          if (window.ResizeObserver && this.parentElement) {
            this.resizeObserver = new ResizeObserver(this.onWidth);
            this.resizeObserver.observe(this.parentElement);
          }

          this.hideNative();
          this.refreshTrigger();
          this.syncWidth();
        }

        disconnectedCallback() {
          if (!this.trigger) return;
          this.close(false);
          document.removeEventListener('keydown', this.onKey);
          document.removeEventListener('change', this.onChange);
          document.removeEventListener('click', this.onAddClick, true);
          window.removeEventListener('resize', this.onResize);
          window.removeEventListener('resize', this.onWidth);
          window.removeEventListener('load', this.onWidth);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (typeof this.unsubscribe === 'function') this.unsubscribe();
          if (this.observer) this.observer.disconnect();
          this.timers.forEach(clearTimeout);
          clearTimeout(this.hideTimer);
          if (this.root && this.root.parentNode) this.root.parentNode.removeChild(this.root);
        }

        /* ---------- Native Dawn inputs (the bridge) ---------- */

        // Inputs that belong to this page's product form (skips the old copy Dawn keeps for half a second while it swaps the picker)
        liveInputs() {
          const stale = this.formId + '-';
          return Array.from(this.scope.querySelectorAll('input[type="radio"], select')).filter((el) => {
            if (this.contains(el) || (this.root && this.root.contains(el))) return false;
            const form = el.getAttribute('form');
            return !(form && form.indexOf(stale) === 0);
          });
        }

        groupOf(el) {
          return el.closest('.product-form__input') || el.closest('fieldset') || el.parentElement;
        }

        groupValues(group) {
          const values = [];
          group.querySelectorAll('input[type="radio"], option').forEach((el) => values.push(el.value));
          return values;
        }

        // The native inputs of option number `index` (0 = first option). Tried in this order:
        //  1. data-option-name (Dawn 15+)   2. input name: "Size", "options[Size]", "Size-2" (Dawn 14, 15, 16)
        //  3. the group that has exactly this option's values   4. the group at this position inside <variant-selects>
        optionInputs(index) {
          const name = this.data.optionNames[index];
          const names = [name, 'options[' + name + ']', name + '-' + (index + 1)];
          const live = this.liveInputs();

          let found = live.filter((el) => el.dataset.optionName === name || names.indexOf(el.name) > -1);
          if (found.length) return found;

          const wanted = (this.data.optionValues[index] || []).slice().sort().join('\u0001');
          if (wanted) {
            const groups = [];
            live.forEach((el) => {
              const group = this.groupOf(el);
              if (group && groups.indexOf(group) < 0) groups.push(group);
            });
            const match = groups.find((group) => this.groupValues(group).sort().join('\u0001') === wanted);
            if (match) return live.filter((el) => match.contains(el));
          }

          const picker = this.scope.querySelector('variant-selects, variant-radios');
          if (picker) {
            const groups = Array.from(picker.children).filter((el) => el.matches('.product-form__input, fieldset'));
            const group = groups[index];
            if (group) return live.filter((el) => group.contains(el));
          }
          return [];
        }

        nativeSizeInputs() {
          return this.optionInputs(this.sizeIndex);
        }

        // Hide the whole native size block (legend + pills) for good
        hideNative() {
          this.nativeSizeInputs().forEach((el) => {
            const group = this.groupOf(el);
            if (!group || group === this.scope) return;
            group.setAttribute('data-on-sd-hidden', '');
            group.style.setProperty('display', 'none', 'important');
          });
        }

        nativeValue(index) {
          const inputs = this.optionInputs(index);
          const radio = inputs.find((el) => el.type === 'radio' && el.checked);
          if (radio) return radio.value;
          const select = inputs.find((el) => el.tagName === 'SELECT');
          return select ? select.value : null;
        }

        currentVariantFromForm() {
          const form = document.getElementById(this.formId);
          const input =
            (form && form.querySelector('[name="id"]')) ||
            this.scope.querySelector('form[action*="/cart/add"] [name="id"]');
          if (!input || !input.value) return null;
          return this.data.variants.find((v) => String(v.id) === String(input.value)) || null;
        }

        // The options currently chosen on the page (read live from the native inputs)
        selectedOptions() {
          const fallback = this.currentVariantFromForm();
          return this.data.optionNames.map((name, index) => {
            const live = this.nativeValue(index);
            if (live !== null && live !== '') return live;
            return fallback ? fallback.options[index] : null;
          });
        }

        selectedSize() {
          const live = this.nativeValue(this.sizeIndex);
          if (live) return live;
          const variant = this.currentVariantFromForm();
          return variant ? variant.options[this.sizeIndex] : null;
        }

        /* ---------- Same width as "Add to cart" ---------- */
        syncWidth() {
          const form = document.getElementById(this.formId);
          const add =
            (form && form.querySelector('[name="add"]')) ||
            this.scope.querySelector('form[action*="/cart/add"] [name="add"]');
          this.style.maxWidth = '';
          if (!add) return;
          const addWidth = add.getBoundingClientRect().width;
          const triggerWidth = this.trigger.getBoundingClientRect().width;
          // only follow a plausible button (a collapsed or hidden button must never squeeze the trigger)
          if (addWidth >= triggerWidth * 0.6 && triggerWidth - addWidth > 1) this.style.maxWidth = addWidth + 'px';
        }

        /* ---------- Trigger text ---------- */
        refreshTrigger() {
          const size = this.chosen ? this.selectedSize() : null;
          this.triggerText.textContent = size || this.dataset.label;
        }

        // Two-way sync: any change of the native size input (even if the pills were still visible), swatch click,
        // Dawn auto-selecting a size, back button...
        nativeChanged(event) {
          const target = event.target;
          if (!target || !target.matches || this.contains(target) || (this.root && this.root.contains(target))) return;
          const form = target.getAttribute && target.getAttribute('form');
          if (!this.scope.contains(target) && form !== this.formId) return;
          if (target.matches('input[type="radio"], select') && this.nativeSizeInputs().indexOf(target) > -1) {
            this.chosen = true;
            this.hideNative();
          }
          this.refreshTrigger();
          // Dawn refreshes the picker a moment later; read it again once it is done
          this.timers.push(setTimeout(() => this.afterVariantChange(), 250));
          if (this.isOpen) this.renderList();
        }

        afterVariantChange() {
          if (!this.isConnected) return;
          this.hideNative();
          this.refreshTrigger();
          this.syncWidth();
          if (this.isOpen) {
            this.renderList();
            this.position();
          }
        }

        /* ---------- Stock ---------- */
        stockFor(variant) {
          const ledger = this.data.ledger && typeof this.data.ledger === 'object' ? this.data.ledger : null;
          const windowStock = window.OnSizeStock && typeof window.OnSizeStock === 'object' ? window.OnSizeStock : null;
          const pick = (map) => {
            if (!map) return null;
            if (variant.sku && map[variant.sku] !== undefined) return Number(map[variant.sku]);
            if (map[variant.id] !== undefined) return Number(map[variant.id]);
            return null;
          };
          let count = pick(ledger);
          if (count === null || isNaN(count)) count = pick(windowStock);
          if (count !== null && !isNaN(count)) return { count: Math.max(0, count), fromLedger: true };
          if (variant.managed) return { count: Math.max(0, variant.qty), fromLedger: false };
          return { count: null, fromLedger: false };
        }

        /* ---------- Build the size list for the current color ---------- */
        renderList() {
          const options = this.selectedOptions();
          const selectedSize = this.chosen ? this.selectedSize() : null;
          const fragment = document.createDocumentFragment();

          // One listing for Men and Women: a size that the chosen gender has in no colour is not listed at all
          let sizeValues = this.data.sizeValues;
          const gender = this.genderIndex > -1 ? options[this.genderIndex] : null;
          if (gender) {
            const own = sizeValues.filter((value) =>
              this.data.variants.some((v) => v.options[this.genderIndex] === gender && v.options[this.sizeIndex] === value)
            );
            if (own.length) sizeValues = own;
          }

          sizeValues.forEach((value) => {
            const variant = this.data.variants.find((v) =>
              v.options.every((optionValue, index) =>
                index === this.sizeIndex ? optionValue === value : options[index] === null || optionValue === options[index]
              )
            );

            let soldOut = !variant || !variant.available;
            let count = null;
            if (variant) {
              const stock = this.stockFor(variant);
              count = stock.count;
              if (stock.fromLedger && stock.count === 0) soldOut = true;
            }

            const item = document.createElement('li');
            const row = document.createElement('button');
            row.type = 'button';
            row.className = 'on-sd-row' + (soldOut ? ' is-soldout' : '') + (value === selectedSize ? ' is-selected' : '');
            row.dataset.value = value;
            if (variant) row.dataset.variantId = variant.id;
            row.setAttribute('aria-pressed', value === selectedSize ? 'true' : 'false');

            const size = document.createElement('span');
            size.className = 'on-sd-row__size';
            size.textContent = value;

            const meta = document.createElement('span');
            meta.className = 'on-sd-row__meta';

            const icon = document.createElement('span');
            icon.className = 'on-sd-row__icon';
            icon.setAttribute('aria-hidden', 'true');

            if (soldOut) {
              meta.textContent = this.dataset.textNotify;
              icon.innerHTML =
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>';
              row.dataset.soldout = 'true';
            } else if (count !== null && count > 0 && count <= this.lowStock) {
              meta.textContent = this.dataset.textLow.replace('{count}', count);
            }

            row.append(size, meta, icon);
            item.appendChild(row);
            fragment.appendChild(item);
          });

          this.list.replaceChildren(fragment);
        }

        /* ---------- Open / close ---------- */
        // Desktop: same left edge and width as the trigger, directly under it (above it when there is more room there).
        // Coordinates are relative to the root, which scrolls with the page, so the list stays attached while scrolling.
        position() {
          const panel = this.panel;
          if (!this.mq.matches) {
            ['left', 'top', 'width', 'maxHeight'].forEach((prop) => (panel.style[prop] = ''));
            return;
          }
          const gap = 8;
          const edge = 12;
          const cap = 560;
          const trigger = this.trigger.getBoundingClientRect();
          const origin = this.root.getBoundingClientRect();

          panel.style.left = trigger.left - origin.left + 'px';
          panel.style.width = trigger.width + 'px';
          panel.style.maxHeight = 'none';
          const natural = Math.min(panel.offsetHeight, cap);
          const below = window.innerHeight - trigger.bottom - gap - edge;
          const above = trigger.top - gap - edge;
          const placeBelow = below >= natural || below >= above;
          const room = Math.max(180, Math.min(cap, placeBelow ? below : above));
          const height = Math.min(natural, room);

          // taller than the room: the sizes scroll inside the list, header and "Size Chart" stay put
          panel.style.maxHeight = room + 'px';
          panel.style.top = (placeBelow ? trigger.bottom - origin.top + gap : trigger.top - origin.top - gap - height) + 'px';
        }

        open() {
          if (this.isOpen) return;
          this.hideNative();
          this.renderList();
          this.updateChartLink();
          this.position();
          this.isOpen = true;
          this.root.classList.add('is-open');
          this.trigger.setAttribute('aria-expanded', 'true');
          if (!this.mq.matches) document.documentElement.classList.add('on-sd-lock');

          requestAnimationFrame(() => {
            const target = this.list.querySelector('.is-selected') || this.list.querySelector('.on-sd-row');
            (target || this.panel).focus({ preventScroll: true });
            if (target) target.scrollIntoView({ block: 'nearest' });
          });
        }

        close(returnFocus = true) {
          if (!this.isOpen) return;
          this.isOpen = false;
          this.root.classList.remove('is-open');
          this.trigger.setAttribute('aria-expanded', 'false');
          document.documentElement.classList.remove('on-sd-lock');
          if (returnFocus) this.trigger.focus({ preventScroll: true });
        }

        // The link is only useful when it has somewhere to go: a "#id" link needs that element on the page
        updateChartLink() {
          const link = this.root.querySelector('[data-on-sd-chart]');
          const footer = this.root.querySelector('[data-on-sd-footer]');
          if (!link || !footer) return;
          const href = link.getAttribute('href') || '';
          footer.hidden = href.charAt(0) === '#' && !document.getElementById(href.slice(1));
        }

        // "Size Chart": open the Size & Fit accordion on this page (handled by on-pdp-accordions.liquid)
        openSizeChart(link, event) {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; // new tab etc.
          event.preventDefault();
          const href = link.getAttribute('href') || '';
          this.close(false); // unlocks page scroll on mobile first
          requestAnimationFrame(() => {
            const detail = { productId: this.dataset.productId, source: 'size-drawer' };
            const handled = !document.dispatchEvent(new CustomEvent('on:size-chart-open', { cancelable: true, detail: detail }));
            if (!handled && href) window.location.href = href;
          });
        }

        rootClick(event) {
          if (event.target.closest('[data-on-sd-close]') || event.target.matches('[data-on-sd-overlay]')) {
            this.close();
            return;
          }
          const chart = event.target.closest('[data-on-sd-chart]');
          if (chart) {
            this.openSizeChart(chart, event);
            return;
          }
          const row = event.target.closest('.on-sd-row');
          if (!row) return;

          if (row.dataset.soldout === 'true') {
            const variantId = row.dataset.variantId ? Number(row.dataset.variantId) : null;
            const variant = this.data.variants.find((v) => v.id === variantId);
            document.dispatchEvent(
              new CustomEvent('on:size-notify', {
                detail: {
                  variantId: variantId,
                  size: row.dataset.value,
                  sku: variant ? variant.sku : null,
                  productId: this.dataset.productId
                }
              })
            );
            const url = this.dataset.notifyUrl;
            if (url) window.location.href = url + (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + (variantId || '');
            this.close();
            return;
          }
          this.select(row.dataset.value);
        }

        // Pass the choice to Dawn's own input so price, cart and URL logic keep working
        select(value) {
          const inputs = this.nativeSizeInputs();
          for (let i = 0; i < inputs.length; i++) {
            const el = inputs[i];
            if (el.tagName === 'SELECT') {
              el.value = value;
              el.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
            if (el.type === 'radio' && el.value === value) {
              el.click();
              break;
            }
          }
          this.chosen = true;
          this.triggerText.textContent = value;
          this.close();
          this.timers.push(setTimeout(() => this.afterVariantChange(), 250));
        }

        // Optional: "Add to bag" opens the picker until a size has been chosen
        addClick(event) {
          if (!this.requireSize || this.chosen || this.isOpen) return;
          const button = event.target.closest ? event.target.closest('[name="add"]') : null;
          if (!button) return;
          const form = document.getElementById(this.formId);
          const belongs = (form && form.contains(button)) || button.getAttribute('form') === this.formId;
          if (!belongs) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.open();
        }

        /* ---------- Keyboard: Esc, Tab trap, Up/Down ---------- */
        keyDown(event) {
          if (!this.isOpen) return;

          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }

          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            const rows = Array.from(this.list.querySelectorAll('.on-sd-row'));
            if (!rows.length) return;
            event.preventDefault();
            const at = rows.indexOf(document.activeElement);
            const next = event.key === 'ArrowDown' ? Math.min(rows.length - 1, at + 1) : Math.max(0, at - 1);
            rows[next < 0 ? 0 : next].focus();
            return;
          }

          if (event.key === 'Tab') {
            const items = Array.from(this.panel.querySelectorAll('a[href], button:not([disabled])')).filter(
              (el) => el.getClientRects().length > 0
            );
            if (!items.length) return;
            const first = items[0];
            const last = items[items.length - 1];
            if (event.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["on-variant-picker"] && !Shopify.designMode) return;
  try {
    /* The colour list on a phone is a single row that scrolls sideways. It runs to the screen edge and the selected colour is scrolled into view */
  if (!customElements.get('on-color-list')) {
    customElements.define(
      'on-color-list',
      class OnColorList extends HTMLElement {
        connectedCallback() {
          this.fit = this.fit.bind(this);
          window.addEventListener('resize', this.fit);
          requestAnimationFrame(() => {
            this.fit();
            this.reveal();
          });
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.fit);
        }

        fit() {
          this.style.removeProperty('--on-bleed');
          if (!window.matchMedia('(max-width: 749px)').matches) return;
          const rect = this.getBoundingClientRect();
          const edge = document.documentElement.clientWidth;
          const rtl = getComputedStyle(this).direction === 'rtl';
          const bleed = Math.max(0, Math.round(rtl ? rect.left : edge - rect.right));
          if (bleed) this.style.setProperty('--on-bleed', bleed + 'px');
        }

        reveal() {
          if (this.scrollWidth <= this.clientWidth) return;
          const current = this.querySelector('input:checked + label');
          if (!current) return;
          const list = this.getBoundingClientRect();
          const cell = current.getBoundingClientRect();
          const room = 20;
          if (cell.right > list.right) this.scrollBy({ left: cell.right - list.right + room });
          else if (cell.left < list.left) this.scrollBy({ left: cell.left - list.left - room });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
